import type { ViewKpiAppearance } from '@salescore/core'
import { Array, Record } from 'effect'

export const buildKpisMapper = (kpis: ViewKpiAppearance[]): Record<string, ViewKpiAppearance> =>
  Record.fromIterableBy(Array.reverse(kpis), (x) => x.id)
